(function (Drupal) {

  Drupal.theme.ajaxProgressIndicatorFullscreen = function () {
    return '<div class="ajax-progress ajax-progress--fullscreen"><div class="ajax-progress__throbber ajax-progress__throbber--fullscreen">&nbsp;</div></div>';
  };

  Drupal.theme.ajaxProgressThrobber = function (message) {
    var messageMarkup = typeof message === 'string' ? Drupal.theme('ajaxProgressMessage', message) : '';
    var throbber = '<div class="ajax-progress__throbber">&nbsp;</div>';
    return '<div class="ajax-progress ajax-progress--throbber">' + throbber + messageMarkup + '</div>';
  };

  Drupal.theme.ajaxProgressMessage = function (message) {
    return '<div class="ajax-progress__message">' + message + '</div>';
  };

})(Drupal);
